export default __webpack_public_path__ + "static/purmerend-eee71c7fa636e5898750a03dfd4dd8f4.webp";